import React from "react";
import { Typography,  Tag } from "antd";
import { DashboardOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const { Title, Text } = Typography;

export const ExpertHeader = ({ userName, expertCode }) => {
  const styles = {
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 16,
      padding: "0 16px"
    },
    headerTitle: {
      margin: 0,
    },
    userInfo: {
      display: "flex",
      alignItems: "center",
      gap: 12,
    },
    expertIdContainer: {
      display: "flex",
      alignItems: "center",
      gap: 6,
      marginTop: 4,
    },
    expertIdText: {
      fontSize: '14px',
      fontWeight: '500',
    },
    greetingContainer: {
      display: 'flex',
      flexDirection: 'column',
    }
  };
  
  // Generate greeting based on time of day
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  return (
    <div style={styles.header}>
      <div>
        <Title level={2} style={styles.headerTitle}>
          <DashboardOutlined /> {getGreeting()}, {userName}!
        </Title>
        
        <div style={styles.greetingContainer}>
          <Text type="secondary">Welcome to your  dashboard</Text>
          
          {/* Display Learner ID if available */}
          {expertCode && (
            <div style={styles.expertIdContainer}>
              <Text style={styles.expertIdText}>
                Expert ID: 
                <Tag 
                  color="gold" 
                  style={{ 
                    marginLeft: '6px', 
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}
                >
                  {expertCode}
                </Tag>
              </Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ExpertHeader.propTypes = {
  userName: PropTypes.string.isRequired,
  expertCode: PropTypes.string,
};